export default function makeOnCopy(options) {
  return {
    onCopy: function onCopy(event, editor) {
      event.preventDefault();
      event.stopPropagation();

      if (editor.value.selection.isExpanded || editor.isVoid(editor.value.startBlock)) {
        editor.copyFragmentToClipboard(event, editor.value.fragment);
      }
    }
  };
}